import { combineReducers} from 'redux'
import user from './user'
export default combineReducers({
  // todos,
  // visibilityFilter,
  user
})


// WEBPACK FOOTER //
// ./src/redux/reducers.js